const events = {
  new_subscriber: 'New Subscriber',
};

const actions = {
  send_notification: 'Send Notification',
};


export default { events, actions };
